import { createModel, RematchDispatch } from '@rematch/core';
import * as promotionService from '../../services/promotion.service';
import { PaginationType } from '../../types/CommonTypes';
import { PromotionData } from '../../types/PromotionData';
import { RootModel } from '../models';
import baseEntity from './base.entity';

export const storeName = 'promotionEntity';

export const promotionEntity: any = createModel<RootModel>()({
  name: storeName,
  state: { ids: {} },
  reducers: {
    ...baseEntity,
  },
  effects: (dispatch: RematchDispatch<typeof promotionEntity>) => ({
    async loadById(id, state): Promise<PromotionData> {
      try {
        const item = state[storeName].ids[id];
        if (item && !item.isSimplified) {
          return item;
        }

        const { data } = await promotionService.getPromotion(id);
        this.saves([data]);
        return data;
      } catch (e) {
        throw new Error(e);
      }
    },
    async load(params): Promise<{ content?: PromotionData[] } & PaginationType> {
      try {
        const res = await promotionService.getPromotions(params);
        const { content } = res.data;
        if (content && content.length) {
          this.saveSimplified(content);
        }
        return res.data;
      } catch (e) {
        throw new Error(e);
      }
    },
    async delete(payload) {
      try {
        await promotionService.deletePromotion(payload);
        this.remove(payload);
      } catch (e) {
        throw new Error(e);
      }
    },
    async create(payload) {
      try {
        const { data: item } = await promotionService.createPromotion(payload);
        this.saves([item]);
        return item;
      } catch (e) {
        throw new Error(e);
      }
    },
    async update(payload) {
      try {
        const { data: item } = await promotionService.updatePromotion(payload);
        this.saves([item]);
        return item;
      } catch (e) {
        throw new Error(e);
      }
    },
  }),
});

export default promotionEntity;
